import type { InterventionSectionContextType } from "./intervention-section-context.type";

import { createContext, useContext } from "react";

const config = {
  contextName: "InterventionSectionContext",
  providerName: "InterventionSectionProvider",
};

export const InterventionSectionContext =
  createContext<InterventionSectionContextType | null>(null);

export const useInterventionSectionContext = () => {
  const contextValue = useContext(InterventionSectionContext);

  if (!contextValue) {
    throw new Error(
      `${config.contextName} must be used within a ${config.providerName}`
    );
  }

  return contextValue;
};
